<template>
  <div class="page">
    <headbar class="header" />
    <component :key="index" :is="page.com" v-for="(page, index) in pages" />
    <footbar class="footbar" />
  </div>
</template>

<script>
import headbar from './headbar'
import footbar from './footbar'

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: this.$t('Home.metaInfo.title'),
      meta: [
        { name: 'keywords', content: '祐众主页,uzoombox,祐众私云,私云管家,安全邮箱,私有云盘,文档管理,内容管理,数据资产管理' },
        { name: 'description', content: '祐众私云 - 主页' }
      ]
    }
  },
  data: function() {
    return {
      pages: [{ name: 'slogan' }, { name: 'feature' }, { name: 'scene' }, { name: 'starter' }]
    }
  },
  computed: {},
  components: {
    headbar,
    footbar
  },
  created: function() {
    this.pages.forEach(obj => {
      obj.com = require('./Home/' + obj.name).default
    })
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.page .header {
  width: 100%;
  height: var(--header-height);
}
.page .footbar {
  width: 100%;
  height: var(--footer-height);
}
</style>
